import React from "react";
import { DatePicker, Input, message, Modal, Table, Popover, Tooltip, Button, Checkbox } from "antd";
import { ShowQuotes } from "./popups/ShowQuotes";
import { AddUpdateWorkOrder } from "./popups/AddUpdateWorkOrder";
import { ChoiceQuoteType } from "./popups/ChoiceQuoteType";
import { QuoteList, QuotePDFList, QuoteRemove } from "../../../models/quote";
import { Config } from "../../../controller/Global";
import { AddUpdateHotSheet } from "./popups/AddUpdateHotSheet";
import { pagination } from "../../../controller/Utils";
import {TrackHeaderLink} from "../TrackHeaderLink";

const { RangePicker } = DatePicker;
const confirm = Modal.confirm;
const Search = Input.Search;


function onChange(e) {
  console.log(`checked = ${e.target.checked}`);
}

export class Quotes extends React.Component {
  state = {
    data: [],
    pagination: pagination,
    value: [],
    loading: false,
    selectedRowKeys: [],
    params: {},
    popvisible: false,
    confirmLoading: false,
    printVisible: false
  };
  showPrintModal = () => {
    this.setState({
      printVisible: true,
    });
  }

  handleOk = () => {
    this.setState({
      printVisible: false,
    });
  }

  handleCancel = () => {
    this.setState({
      printVisible: false,
    });
  }

  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    let symbol = '';
    if (sorter.order === 'descend')
      symbol = '-';
    this.fetch({
      results: pagination.pageSize,
      page: pagination.current,
      ordering: `${symbol}${sorter.field}`,
      ...filters,
    });
  };
  fetch = (params = {}) => {
    this.setState({ loading: true, params: params });
    QuoteList(params)
      .then(response => {
        const pagination = { ...this.state.pagination };
        pagination.total = response.data.count;
        this.setState({
          loading: false,
          data: response.data.results,
          pagination,
        });
      });
  };

  onDateRangeChange = (date, dateString) => {
    this.fetch({
      date_fields: 'created',
      start_date: dateString[0],
      end_date: dateString[1]
    })
  };
  onCheckboxSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  onMultipleRowDeleteClick = () => {
    const { selectedRowKeys } = this.state;
    if (selectedRowKeys.length)
      this.onRowDeleteClick(selectedRowKeys);
    else
      message.info('Please select any one row for delete');
    this.setState({
      selectedRowKeys: []
    })
  };
  onMultipleRowPrintClick = (type = '') => {
    const { selectedRowKeys } = this.state;
    this.setState({ confirmLoading: false });
    if (selectedRowKeys.length) {
      QuotePDFList({ ids: selectedRowKeys, pdf_type: type })
    }
    else {
      let param = this.state.params
      param['pdf_type'] = type
      QuotePDFList(param)
    }
    this.setState({ confirmLoading: false });
  };

  onRowDeleteClick = (keys) => {
    const $this = this;
    confirm({
      title: 'Are you sure delete this quote(s)?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      centered: true,
      onOk() {
        keys.forEach(id => {
          QuoteRemove(id)
            .then(response => {
              message.success('Quote(s) deleted successfully');
              $this.fetch();
            });
        });
      },
    });
  };
  onRowShowClick = (ids, type = Config.constant.quote_type.workorder) => {
    this.setShowQuoteModel(type);
    this.setState({ showQuoteModelData: ids })
  };
  onRowUpdateClick = (moderated, type) => {
    if (type === Config.constant.quote_type.workorder) {
      this.setState({ moderatedWorkOrder: moderated });
      this.setAddUpdateWorkOrderModel(true);
    }
    else {
      this.setState({ moderatedHotSheet: moderated });
      this.setAddUpdateHotSheetModel(true)
    }
  };
  openWorkOrderModal = (moderated) => {
    this.setState({ moderated: false });
    this.setAddUpdateWorkOrderModel(true);
    this.setChoiceQuoteModel(false)
  };
  openHotSheetModel = (moderated) => {
    this.setState({ moderated: false });
    this.setAddUpdateHotSheetModel(true);
    this.setChoiceQuoteModel(false)
  };
  onMultipleRowShowClick = () => {
    const { selectedRowKeys } = this.state;
    if (selectedRowKeys.length)
      this.onRowShowClick(selectedRowKeys);
    else
      message.info('Please select any one row for show');
  };
  columns = [
    {
      title: 'Action',
      render: item => <div className="action-column">
        <a title="View" onClick={() => this.onRowShowClick([item.id], item.type)}><i className="fa fa-eye" /></a>
        <a title="Edit" onClick={() => this.onRowUpdateClick(item.id, item.type)}><i className="fa fa-pencil" /></a>
        <a title="Delete" onClick={() => this.onRowDeleteClick([item.id])}><i className="fa fa-trash" /></a>
      </div>
    }, {
      title: 'Quote Number',
      dataIndex: 'quote_number',
      sorter: true
    }, {
      title: <span className="billto-column-tbl">Generator</span>,
      dataIndex: 'generator',
      render: generator => <Tooltip title={`${generator.address} ${generator.city} ${generator.zip_code}`}><span className="uppercase-letter">{generator.company_name} <br />ID: {generator.account_number}<i className="fa fa-info-circle" /></span></Tooltip>,
      sorter: true
    }, {
      title: <span className="billto-column-tbl">User</span>,
      dataIndex: 'user',
      render: (user) => user ? `${user.first_name} ${user.last_name}` : 'N/A',
      sorter: true
    }, {
      title: <span className="billto-column-tbl">Bill To</span>,
      dataIndex: 'bill_to',
      render: bill_to => <span>{bill_to.company_name}<br /> ID: {bill_to.account_number}</span>,
      sorter: true
    }, {
      title: 'Transporter',
      dataIndex: 'service',
      key: 'transporter',
      render: service =>
        <Popover className="services-popover" content={
          <div className="service-date-pop">
            {service.map((item, index) => <p key={index}>{item.transporter.name}</p>)}
          </div>}
          title="All Transporter">
          <a type="primary">{service[0].transporter.name} <i className="fa fa-info-circle" /></a>
        </Popover>,
      sorter: true
    }, {
      title: 'Service Date',
      dataIndex: 'service',
      key: 'service date',
      sorter: true,
      render: (service) =>
        <Popover className="services-popover" content={<div className="service-date-pop">{service.map((item, index) => <p key={index}>{item.service_date}</p>)}</div>} title="All Service Date">
          <a type="primary">{service[0].service_date} <i className="fa fa-info-circle" /></a>
        </Popover>
    }, {
      title: 'Type',
      dataIndex: 'type',
      sorter: true
    }, {
      title: 'Status',
      dataIndex: 'status',
      sorter: false,
      render: status => <span className={status ? "completed" : "pending"}><i className="fa fa-circle" /></span>
    }
  ];

  setShowQuoteModel(showQuoteModel) {
    this.setState({ showQuoteModel });
  }

  setAddUpdateWorkOrderModel(addUpdateWorkOrderModel) {
    this.setState({ addUpdateWorkOrderModel });
    if (!addUpdateWorkOrderModel)
      this.setState({ moderatedWorkOrder: addUpdateWorkOrderModel })
  }

  setAddUpdateHotSheetModel(addUpdateHotSheetModel) {
    this.setState({ addUpdateHotSheetModel })
    if (!addUpdateHotSheetModel)
      this.setState({ moderatedWorkOrder: addUpdateHotSheetModel })
  }

  setChoiceQuoteModel(showChoiceQuoteModel) {
    this.setState({ showChoiceQuoteModel })
  }

  componentDidMount() {
    this.fetch();
  }

  render() {
    const { pagination, data, loading, selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onCheckboxSelectChange,
    };

    return <div id="main-content">
      <div className="container-fluid">
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-sm-2 col-12">
              <h3 className="main-heading">AB Tracks</h3>
            </div>
            <div className="col-sm-10 col-12">
              <TrackHeaderLink />
            </div>
          </div>
          <div className="row clearfix edit-header">
            <div className="col-lg-4 col-sm-4 col-12">
              <div id="date_range_wrapper">
                <RangePicker onChange={this.onDateRangeChange} />
              </div>
            </div>
            <div className="col-lg-2 col-sm-2 col-2 padding-0 pull-xs-left">
              <button className="btn submit-btn xs-hide" type="button"
                onClick={() => this.setChoiceQuoteModel(true)}>Create Quote
              </button>
              <button className="btn submit-btn xs-show" type="button" onClick={() => this.setChoiceQuoteModel(true)}>
                <i
                  className="fa fa-plus" /></button>
            </div>
            <div className="col-lg-3 col-sm-6 col-10 pull-xs-right">
              <Search placeholder="Input search text" onSearch={value => this.fetch({ search: value })}
                style={{ width: "100%" }} />
            </div>
            <div className="col-lg-3 col-sm-12 col-12 edit-div">
              <span>{pagination.total} Records</span>
              <Button className="btn btn-edit" onClick={this.showPrintModal} type="primary"><i className="icon-printer" /></Button>
              <button className="btn btn-edit" onClick={this.onMultipleRowDeleteClick}>
                <i className="fa fa-trash-o" />
              </button>
              <button type="primary" onClick={this.onMultipleRowShowClick} className="btn btn-edit">
                <i className="fa fa-eye" />
              </button>
            </div>
          </div>
          <div className="row clearfix">
            <div className="col-12">
              <div className="listing-table">
                <Table
                  className="responsive-table table table-hover js-basic-example dataTable table-custom table-striped m-b-0 c_list"
                  pagination={pagination} rowSelection={rowSelection} rowKey={row => row.id} columns={this.columns}
                  dataSource={data} loading={loading} onChange={this.handleTableChange}
                  locale={{ emptyText: 'No Quote Available' }} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal">
        <AddUpdateWorkOrder moderated={this.state.moderatedWorkOrder} visible={this.state.addUpdateWorkOrderModel}
          setModelVisible={() => this.setAddUpdateWorkOrderModel(false)} fetch={() => this.fetch()} />
        <AddUpdateHotSheet moderated={this.state.moderatedHotSheet} visible={this.state.addUpdateHotSheetModel}
          setModelVisible={() => this.setAddUpdateHotSheetModel(false)} fetch={() => this.fetch()} />
      </div>
      <ShowQuotes visible={this.state.showQuoteModel} setModelVisible={() => this.setShowQuoteModel(false)}
        data={this.state.showQuoteModelData} />
      <ChoiceQuoteType visible={this.state.showChoiceQuoteModel} workorder={() => this.openWorkOrderModal(true)}
        hotsheet={() => this.openHotSheetModel(true)}
        setModelVisible={() => this.setChoiceQuoteModel(false)} />
      <Modal
        title="Select Print Option"
        visible={this.state.printVisible}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        okText="Print"
        className="print-modal"
        width={300}
      >
        <div>
          <div className="check-div">
            <Checkbox onChange={onChange}>Print Work Order</Checkbox>
          </div>
          <div className="check-div">
            <Checkbox onChange={onChange}>Print Menifest 1</Checkbox>
          </div>
          <div className="check-div">
            <Checkbox onChange={onChange}>Print Menifest 2</Checkbox>
          </div>
        </div>
      </Modal>
    </div>;
  }
}




// WEBPACK FOOTER //
// ./src/pages/tracks/quotes/Quotes.jsx